export const idSafer = (value) => (value ?? '').replaceAll(".", "_").replaceAll('[', '_').replaceAll(']', '_');